<template>
  <v-menu
    v-model="isOpen"
    open-on-hover
    open-delay="100"
    close-delay="100"
    offset-y
    content-class="mega-menu-content"
    transition="fade-transition"
  >
    <template v-slot:activator="{ props }">
      <div v-bind="props" style="display: inline-block; height: 100%">
        <a
          :href="'/' + link.path"
          class="nav-link"
          :class="{ isActive: isActive }"
          @click.prevent="handleNavigate(link.path)"
        >
          <v-icon
            v-if="link.icon"
            size="22"
            color="black"
            class="ml-1"
            :icon="link.icon"
          />
          {{ link.title }}
        </a>
      </div>
    </template>

    <v-card
      class="mega-menu-card rounded-0"
      elevation="2"
      v-if="link.subCategories && link.subCategories.length > 0"
    >
      <div class="mega-menu-wrapper">
        <!-- Right side (Text Columns) -->
        <div class="mega-menu-links">
          <div
            class="links-column"
            v-for="(col, index) in subCategoryColumns"
            :key="index"
            :class="{ 'ml-6': index === 1 }"
          >
            <a
              class="link-item"
              :class="{ 'border-none': sIndex === col.length - 1 }"
              v-for="(sub, sIndex) in col"
              :key="sub.categoryId"
              :href="'/' + link.path + '/' + sub.slug"
              @click.prevent="handleNavigate(link.path + '/' + sub.slug)"
            >
              {{ sub.categoryName }}
            </a>
          </div>
        </div>

        <!-- Left side (Image) -->
        <div class="mega-menu-image" v-if="link.image">
          <img :src="imageUrl(link.image)" :alt="link.title" />
        </div>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
import config from "@/config";

export default {
  emits: ["navigate"],
  props: {
    link: {
      type: Object,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
      suppressReopen: false,
    };
  },
  watch: {
    isOpen(val) {
      if (val && this.suppressReopen) {
        this.isOpen = false;
      }
    },
  },
  computed: {
    subCategoryColumns() {
      const subs = this.link.subCategories;
      if (!subs || subs.length === 0) return [];
      const half = Math.ceil(subs.length / 2);
      return [subs.slice(half), subs.slice(0, half)];
    },
  },
  methods: {
    imageUrl(image) {
      if (!image) return "";
      if (image.startsWith("http")) return image;
      return `${config.baseURL}${image.startsWith("/") ? "" : "/"}${image}`;
    },
    handleNavigate(path) {
      clearTimeout(this.suppressReopenTimeout);
      this.suppressReopen = true;
      this.isOpen = false;
      this.$emit("navigate", path);
      this.suppressReopenTimeout = setTimeout(() => {
        this.suppressReopen = false;
      }, 300);
    },
  },
};
</script>

<style scoped lang="scss">
.nav-link {
  cursor: pointer;
  padding: 25px 20px;
  font-size: $mediumTextSize;
  text-decoration: none;
  color: $primaryTextColor !important;
  display: inline-flex;
  align-items: center;
  height: 100%;

  &.isActive {
    background-color: $primaryColor;
    color: white !important;
    .v-icon {
      color: white !important;
    }
  }

  &:hover {
    background-color: $primaryColor;
    color: white !important;
    .v-icon {
      color: white !important;
    }
  }
}

@media (max-width: 1440px) {
  .nav-link {
    font-size: 17px !important;
  }
}

.mega-menu-content {
  border-radius: 0;
  margin-top: 1px;
  max-height: none !important;
  overflow: visible !important;
}

.mega-menu-card {
  width: auto;
  min-width: 650px;
  max-width: 90vw;
  background-color: #fff;
  overflow: visible !important;
}

.mega-menu-wrapper {
  display: flex;
  flex-direction: row-reverse;
  gap: 20px;
}

.mega-menu-links {
  display: flex;
  flex: 1;
  gap: 40px;
  flex-direction: row-reverse;
  padding: 15px 20px;
}

.links-column {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.link-item {
  display: block;
  padding: 12px 0;
  border-bottom: 1px solid #eaeaea;
  text-align: right;
  font-size: 15px;
  color: #4a4a4a;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s ease-in-out;

  &:hover {
    color: #bd9478;
  }

  &.border-none {
    border-bottom: none;
  }
}

.mega-menu-image {
  width: 280px;
  min-height: 280px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
